/**
 * Resource-scoped access levels (layer 4 of the permission model).
 *
 * Source of truth: `docs/security/permission-model.md`, «Слой 4 — resource-scoped ACL».
 */
export const ACCESS_LEVELS = ['NONE', 'VIEWER', 'COMMENTER', 'EDITOR', 'MANAGER'];
/** The one place where the order of the scale is written down. */
export const ACCESS_LEVEL_RANK = {
    NONE: 0,
    VIEWER: 1,
    COMMENTER: 2,
    EDITOR: 3,
    MANAGER: 4,
};
export const atLeast = (actual, required) => ACCESS_LEVEL_RANK[actual] >= ACCESS_LEVEL_RANK[required];
//# sourceMappingURL=access-level.enums.js.map